import { saveState, loadState } from 'utils/localStorage'
const defaultInitialState = {
   accessToken: '',
   settings: {},
   user: {
      nombres: '',
      apellidos: '',
      email: '',
      telefono: '',
      tipoDocumentoId: '',
      numeroCedula: '',
      ciudadId: '',
      imagen: ''
   },
   authenticated: false,
   token: {
      access_token: '',
      expires_in: 0,
      refresh_expires_in: 0,
      refresh_expiration_date: 0,
      refresh_token: '',
      token_type: 'bearer',
      'not-before-policy': 0,
      session_state: '',
      scope: ''
   },
   authorizedOptions: {}
}

const loadedState = loadState()

export const initialState = {
   ...defaultInitialState,
   ...(loadedState && Object.keys(loadedState).length > 0 ? loadedState : {})
}

const sessionUserReducer = (state = initialState, action) => {
   if (action.type === 'LOGIN_SESSION' || action.type === 'LOGOUT') {
      saveState({
         ...state,
         token: action.session,
         authenticated: action.authenticated
      })
   }
   switch (action.type) {
      case 'LOGIN_SESSION':
         return {
            ...state,
            token: {
               ...action.session,
               refresh_expiration_date: Date.now() + action.session.refresh_expires_in * 1000
            },
            accessToken: action.accessToken,
            authenticated: action.authenticated,
         }
      case 'LOGOUT':
         // TODO: Remover data proveniente de action
         return {
            ...state,
            token: {},
            accessToken: '',
            settings: {},
            authenticated: false,
            authorizedOptions: {}
         }
      case 'UPDATE_SESSION_DATA':
         return {
            ...state,
            ...action.payload
         }

      default:
         return state
   }
}

export default sessionUserReducer
